import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material';
import { useState } from 'react';

interface SendEmailHtmlViewerProps {
  html: string;
}

export function SendEmailHtmlViewer(props: SendEmailHtmlViewerProps) {
  const { html } = props;

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button variant="outlined" onClick={() => setIsDialogOpen(true)}>
        View Sent E-mail
      </Button>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullScreen>
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <IconButton aria-label="Close" onClick={() => setIsDialogOpen(false)}>
            <ArrowBackIcon />
          </IconButton>
          <span>Sent E-mail</span>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} height="100%">
            <Box flex={1}>
              <iframe
                name="html-preview"
                src={`data:text/html;charset=utf-8,${encodeURIComponent(html)}`}
                width="100%"
                height="100%"
                sandbox=""
              />
            </Box>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
